'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.externalUrls = exports.producerAppUrls = exports.managerAppUrls = exports.creatorAppUrls = exports.marketplaceUrls = exports.brandAppUrls = exports.supportUrls = exports.supportBaseUrlBrands = exports.supportBaseUrlsCreators = exports.vaasUrls = exports.matchingBaseUrls = exports.managerAppBaseUrls = exports.marketplaceAppBaseUrls = exports.contentManagerAppBaseUrls = exports.producerAppBaseUrls = exports.creatorAppBaseUrls = exports.brandAppBaseUrls = exports.vaasBaseUrls = exports.DASHBOARD_URL = exports.REQUEST_TICKETS_URL = exports.HTTP_SCHEMA = undefined;

var _domain = require('../enums/domain');

var _a, _b, _c, _d, _e, _f, _g, _h;
var HTTP_SCHEMA = exports.HTTP_SCHEMA = 'https://';
var REQUEST_TICKETS_URL = exports.REQUEST_TICKETS_URL = '/requests/';
var DASHBOARD_URL = exports.DASHBOARD_URL = '/dashboard';
var TABLEAU_BASE_URL = 'https://us-west-2b.online.tableau.com/#/site/90seconds/views';
var vaasBaseUrls = exports.vaasBaseUrls = (_a = {}, _a[_domain.Domain.DEVELOPMENT] = 'app.90seconds.dev', _a[_domain.Domain.TEAM] = 'core.90seconds.team', _a[_domain.Domain.STAGING] = 'app.90seconds.cc', _a[_domain.Domain.PRODUCTION] = 'app.90seconds.com', _a);
var brandAppBaseUrls = exports.brandAppBaseUrls = (_b = {}, _b[_domain.Domain.DEVELOPMENT] = 'brand.90seconds.dev', _b[_domain.Domain.TEAM] = 'brand.90seconds.team', _b[_domain.Domain.STAGING] = 'brand.90seconds.cc', _b[_domain.Domain.PRODUCTION] = 'brand.90seconds.com', _b);
var creatorAppBaseUrls = exports.creatorAppBaseUrls = (_c = {}, _c[_domain.Domain.DEVELOPMENT] = 'creator.90seconds.dev', _c[_domain.Domain.TEAM] = 'creator.90seconds.team', _c[_domain.Domain.STAGING] = 'creator.90seconds.cc', _c[_domain.Domain.PRODUCTION] = 'creator.90seconds.com', _c);
var producerAppBaseUrls = exports.producerAppBaseUrls = (_d = {}, _d[_domain.Domain.DEVELOPMENT] = 'producer.90seconds.dev', _d[_domain.Domain.TEAM] = 'producer.90seconds.team', _d[_domain.Domain.STAGING] = 'producer.90seconds.cc', _d[_domain.Domain.PRODUCTION] = 'producer.90seconds.com', _d);
var contentManagerAppBaseUrls = exports.contentManagerAppBaseUrls = (_e = {}, _e[_domain.Domain.DEVELOPMENT] = 'contentmanager.90seconds.com', _e[_domain.Domain.TEAM] = 'contentmanager.90seconds.com', _e[_domain.Domain.STAGING] = 'contentmanager.90seconds.com', _e[_domain.Domain.PRODUCTION] = 'contentmanager.90seconds.com', _e);
var marketplaceAppBaseUrls = exports.marketplaceAppBaseUrls = (_f = {}, _f[_domain.Domain.DEVELOPMENT] = 'explore.90seconds.dev', _f[_domain.Domain.TEAM] = '90seconds.team', _f[_domain.Domain.STAGING] = 'explore.90seconds.cc', _f[_domain.Domain.PRODUCTION] = '90seconds.com', _f);
var managerAppBaseUrls = exports.managerAppBaseUrls = (_g = {}, _g[_domain.Domain.DEVELOPMENT] = 'manager.90seconds.dev', _g[_domain.Domain.TEAM] = 'manager.90seconds.team', _g[_domain.Domain.STAGING] = 'manager.90seconds.cc', _g[_domain.Domain.PRODUCTION] = 'manager.90seconds.com', _g);
var matchingBaseUrls = exports.matchingBaseUrls = (_h = {}, _h[_domain.Domain.DEVELOPMENT] = 'matching.90seconds.dev', _h[_domain.Domain.TEAM] = 'matching.90seconds.team', _h[_domain.Domain.STAGING] = 'matching.90seconds.cc', _h[_domain.Domain.PRODUCTION] = 'matching.90seconds.com', _h);
var vaasUrls = exports.vaasUrls = {
    workContracts: 'work_contracts',
    activeWorkContracts: 'work_contracts?type=started',
    paidWorkContracts: 'work_contracts?type=paid',
    videoProjects: 'video_projects',
    jobs: 'jobs',
    signIn: 'human/sign_in',
    signOut: 'sign_out',
    humans: 'humans',
    ratings: 'ratings',
    purchasesDashBoard: 'dashboards/purchases',
    sales: 'sales',
    producerDashBoard: 'dashboard/my-success',
    videoProjectOverview: 'dashboards/video_projects_overview',
    creationForecast: 'dashboards/creation_forecast',
    freelancers: 'freelancers',
    creatorActivation: 'dashboards/creator_activation',
    coverage: 'freelancers/heatmap',
    successManagement: 'dashboards/success_management',
    search: 'search',
    paymentIn: 'dashboards/receivable_invoices',
    paymentOut: 'dashboards/pay_freelancers',
    revenueAdjustment: 'finance_dashboard/revenue_report',
    oldReport: 'dashboards/old_90_reports',
    topBrands: 'dashboards/top_brands',
    brandRetention: 'dashboards/retention',
    brandActivation: 'dashboards/brand_activation',
    growth: 'dashboards/growth',
    settings: 'settings',
    organisations: 'organisations',
    projects: 'projects'
};
var supportBaseUrlsCreators = exports.supportBaseUrlsCreators = "https://90seconds.com/support/?s=for-creators";
var supportBaseUrlBrands = exports.supportBaseUrlBrands = "https://90seconds.com/support/?s=for-brands";
var supportUrls = exports.supportUrls = {
    howDoIGetJobs: 'faq/how-do-i-get-jobs',
    understandingYourContract: 'getting-jobs/understanding-your-contract',
    howMuchWorkIsInMyArea: 'faq/how-much-work-is-in-my-area'
};
var brandAppUrls = exports.brandAppUrls = {
    create: 'create',
    templates: 'templates'
};
var marketplaceUrls = exports.marketplaceUrls = {
    products: '#products',
    video_products: 'video-products',
    howItWork: 'how-it-works',
    premium: 'premium',
    pricing: 'premium/pricing',
    coverage: 'coverage',
    creators: 'for-creators',
    about_us: 'about',
    careers: 'about/careers',
    testimonials: 'about/testimonials/',
    brand_terms: 'brand-terms',
    brands: 'brands'
};
var creatorAppUrls = exports.creatorAppUrls = {
    dashboard: 'dashboard',
    accountDetails: 'account/personal-details',
    skills: 'account/skills',
    payments: 'account/payments'
};
var managerAppUrls = exports.managerAppUrls = {
    dashboard: 'dashboard',
    requests: 'requests',
    producers: 'producers'
};
var producerAppUrls = exports.producerAppUrls = {
    dashboard: 'dashboard'
};
var externalUrls = exports.externalUrls = {
    creationDashboard: TABLEAU_BASE_URL + "/CreationsHolistics/DashboardforCreations",
    jobForecastDashboard: TABLEAU_BASE_URL + "/JobsForecastedJobsOverdue-HolisticsMigrated/JobsForecastedDashboard",
    jobOverdueDashboard: TABLEAU_BASE_URL + "/JobsForecastedJobsOverdue-HolisticsMigrated/JobsOverdue",
    projectRatingDashboard: TABLEAU_BASE_URL + "/ProducersRatings/RatingsProducersProjects"
};
//# sourceMappingURL=urls.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/web-ui/dist/config/data/urls.js
// module id = 967
// module chunks = 0